import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { LoginService } from '../../services/login/login.service';

@Component({
    selector:'app-deudas',
    templateUrl:'./deudas.component.html',
    styleUrls: ['./deudas.component.scss'],
})

export class DeudasComponent   {
    abrirRegistroDeudas : boolean = false;
    deuda : any;
    constructor(private loginService:LoginService,private router : Router){}


    clickGuard(){
        this.loginService.clickGuard = true;
    }

    crearRegistroDeudas(){
        this.deuda = [];
        this.abrirRegistroDeudas = true;
    }

    CerrarPopUpRegDeudas(Click:boolean){
        this.abrirRegistroDeudas = false;
    }
    Refresh(){
        this.loginService.clickGuard = true;
        let currentUrl = this.router.url;
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
            this.loginService.clickGuard = true;
            this.router.navigate([currentUrl]);
        });
    }
}